import styled from "styled-components";

const Hint = styled.span`
  font-size: 12px;
  color: ${props => props.theme.textExplanation};
`;

export default Hint;
